// global feature flags
module.exports = {
  favicons: {
    flag: 'cs-favicons',
    enabled: 'enabled',
    disabled: 'disabled',
  },
  privacyProxy: {
    flag: 'sea-privacy-proxy',
    enabled: 'st_cloudflare',
    disabled: 'st_control',
  },
  privacyProxyMs: {
    flag: 'sea-privacy-proxy-ms',
    enabled: 'st_cloudflare',
    disabled: 'st_control',
  },
  searchShortcuts: {
    flag: 'cs-460-shortcuts',
    variantA: 'st_ab_shortcuts_a',
    variantB: 'st_ab_shortcuts_b',
    variantC: 'st_ab_shortcuts_c',
    control1: 'st_ab_shortcuts_ctrl1',
    control2: 'st_ab_shortcuts_ctrl2',
  },
  toursActivitiesAdFormat: {
    flag: 'cs-567-tours-activities',
    enabled: 'st_ab_tour_enbl_off', // TODO: remove the `_off` suffix when the feature is ready for release
    disabled: 'st_ab_tour_ctrl_off', // TODO: remove the `_off` suffix when the feature is ready for release
  },
  personalCounterUserOnboarding: {
    flag: 'jo-personal-counter-user-onboarding-experiment',
    enabled: 'enabled',
    disabled: 'disabled',
  },
  webProductAdsFullwidthExperiment: {
    flag: 've-product-ads-fullwidth',
    disabled: 'st_ab_ve-907_product_ads_fullwidth_ctrl',
    enabled: 'st_ab_907_product-ads-fullwidth-test',
  },
  shoppingBingExperiment: {
    flag: 'jo-shopping-bing',
    enabled: 'enabled',
    disabled: 'default',
  },
  adRevenueExperiment: {
    flag: 'cs-652-revenue',
    disabled: 'disabled',
    control1: 'st_ab_rev_1',
    control2: 'st_ab_rev_2',
    variantA: 'st_ab_rev_a',
    variantB: 'st_ab_rev_b',
    variantC: 'st_ab_rev_c',
    variantD: 'st_ab_rev_d',
    variantE: 'st_ab_rev_e',
    variantX: 'st_ab_rev_x',
  },
  stickyHeaderExperiment: {
    flag: 'cs-566-sticky-header',
    ctrl: 'control',
    completelySticky: 'completely_sticky',
    scrollUp: 'scroll_up',
    minimalise: 'minimalise',
  },
};
